export default __webpack_public_path__ + "static/media/lightbulb.ba1c79f3.png";